module.exports = __webpack_public_path__ + "img/snips_snipcoins.95a21dd.png";